// Constants
import {
    TIMESHEET_LOAD_REQUESTED,
    TIMESHEET_LOAD_SUCCEEDED,
    TIMESHEET_LOAD_FAILED,
    TIMESHEET_LOAD_CANCELED,
    TIMESHEET_CREATE_REQUESTED,
    TIMESHEET_CREATE_SUCCEEDED,
    TIMESHEET_CREATE_FAILED,
    TIMESHEET_UPDATE_REQUESTED,
    TIMESHEET_UPDATE_SUCCEEDED,
    TIMESHEET_UPDATE_FAILED,
    TIMESHEET_SET
} from './constants';

// Types
import type { Timesheet } from '../timesheets/types';

export function requestLoadTimesheet(timesheetId: number) {
    return {
        type: TIMESHEET_LOAD_REQUESTED,
        payload: {
            timesheetId
        }
    };
}

export function succeededLoadTimesheet(response: Object) {
    return {
        type: TIMESHEET_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadTimesheet(error: Error) {
    return {
        type: TIMESHEET_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadTimesheet() {
    return {
        type: TIMESHEET_LOAD_CANCELED,
        payload: {}
    };
}

export function requestCreateTimesheet(data: Object) {
    return {
        type: TIMESHEET_CREATE_REQUESTED,
        payload: {
            data
        }
    };
}

export function succeededCreateTimesheet(response: Object) {
    return {
        type: TIMESHEET_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateTimesheet(error: Error) {
    return {
        type: TIMESHEET_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUpdateTimesheet(timesheetId: number, data: Timesheet) {
    return {
        type: TIMESHEET_UPDATE_REQUESTED,
        payload: {
            timesheetId,
            data
        }
    };
}

export function succeededUpdateTimesheet(response: Object) {
    return {
        type: TIMESHEET_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateTimesheet(error: Error) {
    return {
        type: TIMESHEET_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function setTimesheet(data: Timesheet) {
    return {
        type: TIMESHEET_SET,
        payload: data
    };
}
